import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import AntIcon from "../../../../common/components/icons/AntIcon";

type Props = {
  showSettingsModal: () => void;
};

export const DashboardSettingsButton = ({ showSettingsModal }: Props) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t("dashboard.actions.settings")}>
      <span>
        <AntIcon onClick={showSettingsModal} style={{ fontSize: 24, cursor: "pointer" }} color="grey" type="settings" />
      </span>
    </Tooltip>
  );
};
